<template id="app-header">
  <div class="app-header">
    <b-navbar toggleable="lg" type="dark" fixed="top" style="background-color: #3E3E3E; position: sticky; top: 0;">
      <b-navbar-brand href="#">
        <img class="d-inline-block" :src=logoPath width="150px" height="25px"/>
        <br>
        <b style="font-size: x-small; float: right;">Powered by <a style="padding:0px;"
                                                                   href="https://compegence.com/products"><i
            style="color: #4785ee">Fore</i><i style="color: #e31717">Warn</i></a></b>

      </b-navbar-brand>
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <div class="mobile-menu" v-b-tooltip.hover title="Navigation" @click="toggleSideMenu">
        <i class="fa fa-list-ul" style="color:grey" v-if="showSideMenu"></i>
        <i class="fa fa-expand fa-md" style="color:white" v-if="!showSideMenu"></i>
      </div>
      <b-collapse class="collapse navbar-collapse justify-content-end" id="nav-collapse" is-nav>

        <b-navbar-nav>


          <b-nav-item :to="homeIconUrl" v-b-tooltip.hover title="Home">
            <i class="fa fa-home fa-md"></i>
          </b-nav-item>

          <b-nav-item to="/annotation-messages/Parent/C">
            <i class="fa-stack fa-md mt-n1">
              <i class="fas fa-envelope fa-stack-1x"></i>
              <i class="fa fa-circle fa-xs fa-stack icon-alignment"
                 style="margin-left:12px;margin-top:-14px">
                <div class="icon-alignment-round top-menu-icon">
                  <div class="top-menu-icon-text">{{  $store.state.annotationCount }}</div>
                </div>
              </i>
            </i>
          </b-nav-item>

          <b-nav-item-dropdown v-bind:text="$store.state.firstName" toggle-class="nav-link-custom" class="txt-algn">
            <b-dropdown-item to="/change-password">Change Password</b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item v-b-tooltip.hover title="Current Role" style="font-size: 14px">
            <i class="fa fa-users fa-md"></i>
            <span class="text-white font-weight-bold ml-1">{{ $store.state.roleName }}</span>
          </b-nav-item>

          <b-nav-item-dropdown text="Help" toggle-class="nav-link-custom" class="txt-algn">
            <b-dropdown-item to="/about">About ForeWarn</b-dropdown-item>
            <b-dropdown-item to="/release-notes">Latest Release Note</b-dropdown-item>
          </b-nav-item-dropdown>

          <b-nav-item v-b-tooltip.hover title="Collapse / Expand Banner" @click="toggleBanner">
            <i class="fa fa-toggle-off fa-md" style="color:grey" v-if="showBanner"></i>
            <i class="fa fa-toggle-on fa-md" style="color:white" v-if="!showBanner"></i>
          </b-nav-item>
          <!--          <b-nav-item v-b-tooltip.hover title="Full Screen" @click="toggleSideMenu">
                      <i class="fa fa-expand fa-md" style="color:grey" v-if="showSideMenu"></i>
                      <i class="fa fa-expand fa-md" style="color:white" v-if="!showSideMenu"></i>
                    </b-nav-item>
                    <b-nav-item v-b-tooltip.hover title="Navigation" @click="showMenu">
                      <i class="fa fa-list-ul" style="color:grey" v-if="showSideMenu"></i>
                      <i class="fa fa-expand fa-md" style="color:white" v-if="!showSideMenu"></i>
                    </b-nav-item>-->
          <!--          <b-nav-item v-b-tooltip.hover title="Sign Out">-->
          <!--               <router-link to="logout"> <i class="fa fa-sign-out-alt fa-md"></i></router-link>-->
          <!--          </b-nav-item>-->
          <b-nav-item v-b-tooltip.hover title="Sign Out" @click="logout">
            <i class="fa fa-sign-out-alt fa-md"></i>
          </b-nav-item>

        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <!--Vue Bootstrap Modal-->
    <b-modal ref="my-modal" hide-footer title="">
      <template v-slot:modal-title>
        <p style="font-weight: normal;font-size: 14px">You have logged in as <br> <span
            class="font-weight-bold">User Name :</span>
          {{ $store.state.firstName }} |
          <span class="font-weight-bold">Role :</span> {{ $store.state.roleName }} |
          <span class="font-weight-bold">since :</span>
          <span v-for="(x,idx) in roleName" v-bind:key="idx">{{ x.updateTimestamp }}</span>
        </p>
      </template>
      <div class="d-block text-center">
        <p>
          You have requested role switch from <span class="text-primary">{{ $store.state.roleName }}</span>
          to <span class="text-success">{{ switchedRole }}</span> <br>
          Do you like to make the role switch? (Y/N)
        </p>

      </div>
      <b-button class="mt-3 btn-danger btn-sm float-right" btn-sm @click="hideModal" v-b-tooltip.hover
                title="Cancel">
        <i class="fa fa-window-close"></i>
      </b-button>
      <b-button class="mt-3 btn-success btn-sm float-right" btn-sm @click="updateRole(rId)" v-b-tooltip.hover
                title="Proceed">
        <i class="fa fa-check"></i>
      </b-button>
    </b-modal>
  </div>
</template>
<script>
import axios from 'axios'

export default {
  name: 'AppHeader',
  components: {},
  data: function () {
    return {
      level1Menu: [],
      level2Menu: [],
      topMenu: [],
      menuMaster: {},
      fwMClient: {},
      userInfo: {},
      user: '',
      sideMenu: [],
      level1MenuFlag: false,
      level2MenuFlag: false,
      roleName: [],
      switchedRole: '',
      rId: '',
      logoPath: null
    }
  },
  mounted: function () {
    this.getMenuMaster()
    this.getLogoPath()
  },
  computed: {
    showBanner() {
      return this.$store.state.showBanner
    },
    showSideMenu() {
      return this.$store.state.showSideMenu
    },
    isLoggedIn() {
      return this.$store.state.isLoggedIn
    },
    roleSwitchConfirmation() {
      return this.$store.state.roleSwitchConfirmation
    },
    homeIconUrl() {/*
      if (this.$store.state.filterType !== undefined) {
        this.isToggled = this.$store.state.filterType === "dialog-filter";
      } else if (this.$store.state.userRoleRestriction.filterType !== undefined) {
        this.isToggled = this.$store.state.userRoleRestriction.filterType === "dialog-filter";
      } else {
        this.isToggled = false;
      }*/
      let url;

      const {homeDashboardMenuId} = this.$store.state.user;
      const roleLevelMenuId = this.$store.state.userRoleRestriction.homeDashboardMenuId;

      if (!homeDashboardMenuId) {
        url = roleLevelMenuId || '/';
        console.log("Role level dashboard");
      } else {
        url = homeDashboardMenuId || '/';
        console.log("User level dashboard");
      }

      if (!url.includes('/')) {
        // to do need to re-look this logic
        // (checking if it is just a menu id without / then re-direct to home page)
        url = '/'
      }
      return url
    }
  },
  created() {
    this.loadRoleData()
    this.getLogoPath()
  },
  methods: {
    myFunction: function () {
      document.getElementById('myDropdown').classList.toggle('show')
    },
    // Close the dropdown if the user clicks outside of it
    windowonclick: function (event) {
      if (!event.target.matches('.dropbtn')) {
        var dropdowns = document.getElementsByClassName('dropdown-content')
        var i
        for (i = 0; i < dropdowns.length; i++) {
          var openDropdown = dropdowns[i]
          if (openDropdown.classList.contains('show')) {
            openDropdown.classList.remove('show')
          }
        }
      }
    },
    //logout router push
    logout: function () {
      console.log("Signing off")
      this.$router.push('/logout')
    },
    //Post Request
    updateRole: function () {
      axios.post('/auth/session').then(() => {
        this.saveRole()
      }, error => {
        console.log('Error in updating logout session', error)
      })
      //on click of check button hide modal
      this.$refs['my-modal'].hide()
      //vue toast message for successful roll switch
      this.$store.commit('roleSwitchConfirmation')
    },
    saveRole: function () {
      axios.post(`/auth/rolesession/`, this.rId)
          .then(() => {
            this.roleUpdate()
          }, err => {
            console.log('Error in Inserting Record', err)
          })
    },
    roleUpdate: function () {
      let uId = this.$store.state.user.userRoles.userId
      axios.put('/auth/roleFlag/' + this.rId + '/' + uId)
          .then((res) => {
            this.handleRole(res.data)
          }, err => {
            console.log('Error in Updating Record', err)
          })
    },
    handleRole: function () {
      this.$store.dispatch('checkUserLogin')
    },
    //Vue Bootstrap Modal for show
    showModal(roleName, roleId) {
      this.switchedRole = roleName
      this.rId = roleId
      this.$refs['my-modal'].show()
    },
    //Vue Bootstrap Modal for hide
    hideModal() {
      this.$refs['my-modal'].hide()
    },
    loadRoleData: function () {
      //fetching userId from state function
      let uId = this.$store.state.user.userRoles.userId
      //parameter passing as uid to get user roles and display it in UI nav bar
      let url = '/api/roleSwitchData/' + uId
      axios.get(url)
          .then(res => {
            let respDataStr = res.data
            //Parsing json to array
            let jsObject = JSON.parse(respDataStr)
            this.roleSwitchD = jsObject
            //Calling roleId from State.store to filter role name
            let roleSelected = this.$store.state.user.userRoles.roleId
            //filtered rolename based on roleid
            this.roleName = this.roleSwitchD.filter(r => r.roleId != roleSelected)
          }, err => {
            console.log('Error in fetching record', err)
          })
    },
    toggleBanner: function () {
      this.$store.commit('toggleBanner',this.showBanner)
    },

    toggleSideMenu: function () {
      this.$store.commit('toggleSideMenu')
    },
    showMenu: function () {
      let element = document.getElementById("menunav");
      element.classList.remove("d-none")
      element.classList.add("float-menu");
    },
    ifRoute: (what) => {
      return what === location.pathname
    },
    getMenuMaster: function () {
      console.log('appheader', 'load state ')
      this.$store.dispatch('loadState').then((cfg) => {
        this.menuMaster = cfg.menuMasterData
        this.topMenu = this.menuMaster.filter(m => m.parentMenuId === 'Parent')
        this.sideMenu = this.menuMaster.filter(m => m.parentMenuId === 'Root')
      })
    },
    getLogoPath: function () {
      console.log('logo-path', 'load state');
      this.$store.dispatch("loadState").then((cfg) => {
        console.log("logooo", cfg.fwMClient)
        this.fwMClient = cfg.fwMClient
        this.logoPath = "/img" + this.fwMClient[0].clientLogoPath['desktop']
        console.log("client", this.fwMClient)
      })
    }
  }
}

</script>
<style scoped>

.icon-alignment {
  color: Tomato;
  margin-left: 38px;
  margin-top: -25px
}

.icon-alignment-round {
  font-size: 14px;
  margin-left: -20px;
  color: white;
  font-weight: bold;
  vertical-align: top;
}

.top-menu-icon {
  margin-left: -14px;
  font-size: 11px;
  vertical-align: top;
}

.top-menu-icon-text {
  margin-left: 14px;
  margin-top: -26px;
}

.bck-color {
  color: green;
  font-weight: bold;
}

.txt-algn {
  margin-top: -11px;
  margin-left: 10px;
  font-size: 14px;
  line-height: 15px;
}

.dropdown-content {
  display: none;
  position: absolute;
  background-color: #f1f1f1;
  min-width: 160px;
  overflow: auto;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
}

.dropdown-content a {
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}

.dropdown a:hover {
  background-color: #ddd;
}

.show {
  display: block;
}

.dropbtn {
  background-color: #3498DB;
  color: white;
  padding: 16px;
  font-size: 16px;
  border: none;
  cursor: pointer;
}

.dropbtn:hover, .dropbtn:focus {
  background-color: #2980B9;
}

.dropdown {
  position: relative;
  display: inline-block;
}

.mobile-menu {
  display: block;
  margin: auto;
}

/*@media (max-width: 768px) {
 !* Mobile *!
  .mobile-menu{
    display: block;
    margin:auto ;
  }
}*/
</style>